module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_1-898d2641b2176b9a32357e0c39cec426.png";